// extracted by mini-css-extract-plugin
export default {"image":"ShowImage_image__4DNsr"};